// Generated types for MBSE_Requirement
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { SysMLElementReadAPI, SysMLElementWriteAPI } from '../../sysml/types/sysmlelement';
import { SysMLElementReadAPISchemaObject, SysMLElementWriteAPISchemaObject } from '../../sysml/types/sysmlelement';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface MBSE_RequirementReadAPI extends SysMLElementReadAPI {
  /** Overarching category */
  heading: string;
  /** Priority level 1-5 */
  priority?: number;
}

export interface MBSE_RequirementWriteAPI extends SysMLElementWriteAPI {
  /** Overarching category */
  heading: string;
  /** Priority level 1-5 */
  priority?: number;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const MBSE_RequirementReadAPISchema: z.ZodType<MBSE_RequirementReadAPI> = SysMLElementReadAPISchemaObject.extend({
  heading: z.string(),
  priority: z.number().optional(),
}).passthrough();

export const MBSE_RequirementWriteAPISchema: z.ZodType<MBSE_RequirementWriteAPI> = SysMLElementWriteAPISchemaObject.extend({
  heading: z.string(),
  priority: z.number().optional(),
}).passthrough();
